import styled from "styled-components";
import { motion } from "framer-motion";

export const MedicoSolicitanteContainer = styled(motion.div)`
  width: 100%;
  padding: 0 14px;
  .ValidaTurno-separador {
    height: 2px;
    margin: 20px;
    background-color: var(--color-grey95);
  }
`;
export const MedicoSolicitanteTitulo = styled.div`
  display: flex;
  justify-content: center;
`;

export const MainContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${({ $idTerminal }) =>
    $idTerminal
      ? `
    width: 60%;
  `
      : `
    width: 100%;
  `}
`;
export const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40%;
`;

export const MedicoSolicitanteBody = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  .ValidaTurno-bodytxt {
    text-align: center;
  }
  .ValidaTurno-input {
    width: 190px;
    padding-top: 0px;
  }
  /* Fila para input + botones en una misma línea (mobile y desktop) */
  .ValidaTurno-row {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    justify-content: center;
    @media (max-width: 768px) {
      justify-content: center;
      gap: 2px;
    }
  }
`;

export const ResumenBotones = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  button {
    width: 215px;
    height: 45px;
    font-weight: 500;
    font-size: 18px;
    line-height: 150%;
    color: var(--color-white);
    background-color: var(--color-primary);
    border-radius: 8px;
  }
  .danger {
    background-color: var(--color-danger);
  }
  @media (min-width: 768px) {
    gap: 12px;
  }
  @media (max-width: 450px) {
    flex-direction: column;
  }
`;
